import { send } from 'server';
import { initiateDocumentUpload, getJWTToken, checkInDotComListener } from '@core/js/hooks/usePublicAPI/hooks/useServerPublicAPI/server';

const checkIfUsernameIsAvailable = ({ token, casinoName, phone, ...params }) => send({
	ID: 31003,
	description: 'Checks if username is available',
	responses: [31004, 33007],
	casinoName,
	phone,
	...token && { token },
	...params
});

export { initiateDocumentUpload, getJWTToken, checkInDotComListener, checkIfUsernameIsAvailable };
